import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react'

import {
  ECreateScanMode,
  EScanRecordType,
  IAccountByIdRawRespDto,
  IProductByIdRawRespDto,
  IScanProductImpact,
  IStepByIdRawRespDto,
} from 'src/types'

interface IContext {
  setRelations: Dispatch<SetStateAction<IContext['relations']>>
  relations: {
    account: IAccountByIdRawRespDto | null
    step: IStepByIdRawRespDto | null
    product: IProductByIdRawRespDto | null
    impact: IScanProductImpact | null
  }
  formType: EScanRecordType
  setFormType: Dispatch<SetStateAction<IContext['formType']>>
  step: number | null
  setStep: Dispatch<SetStateAction<IContext['step']>>
  createScanMode: ECreateScanMode
  setCreateScanMode: Dispatch<SetStateAction<IContext['createScanMode']>>
}

const ScanRelationContext = createContext<IContext>({
  setRelations: () => {},
  relations: {
    account: null,
    step: null,
    product: null,
    impact: null,
  },
  formType: EScanRecordType.General,
  setFormType: () => {},
  step: null,
  setStep: () => {},
  createScanMode: ECreateScanMode.Default,
  setCreateScanMode: () => {},
})

export const useScanRelationContext = () => useContext(ScanRelationContext)

interface IProps {
  account: IAccountByIdRawRespDto | null
  product: IProductByIdRawRespDto | null
  step: IStepByIdRawRespDto | null

  camera?: boolean
  children: ReactNode
  formType: IContext['formType']
  setFormType: Dispatch<SetStateAction<IContext['formType']>>
  createScanMode: IContext['createScanMode']
  setCreateScanMode: Dispatch<SetStateAction<IContext['createScanMode']>>
}

export const RelationContext = (props: IProps) => {
  const [step, setStep] = useState<IContext['step']>(
    props.camera ? null : props.step ? 3 : props.product ? 2 : props.account ? 1 : 0,
  )
  const [relations, setRelations] = useState<IContext['relations']>({
    account: props.account || null,
    product: props.product || null,
    step: props.step || null,
    impact: null,
  })

  return (
    <ScanRelationContext.Provider
      value={{
        step,
        setStep,
        formType: props.formType,
        setFormType: props.setFormType,
        createScanMode: props.createScanMode,
        setCreateScanMode: props.setCreateScanMode,
        relations,
        setRelations,
      }}
    >
      {props.children}
    </ScanRelationContext.Provider>
  )
}
